const pageNameKey = "alarmProfileEmailRecipientsDrawerModal";

export const alarmProfileEmailRecipientsDrawerModalEn = {
  [pageNameKey]: {
    title: "Condition Monitoring Profile Email Recipients",
    alarmNotificationsSwitchBoxText: "Email alarm notifications",
    iconAltText: "User",
    addAlarmRecipientsTitle: "Add Condition Monitoring Recipients",
    enterEmailAddressText: "Enter email address",
    helpText: "Help",
    addRecipientButton: "Add Recipient",
    recipientsListTitle: "Recipients",
    invalidEmailText: "Invalid email address",
    duplicateEmailText: "Email address already exists",
  },
};

export const alarmProfileEmailRecipientsDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Destinatários de e-mail do perfil de monitoramento de condições",
    alarmNotificationsSwitchBoxText: "Notificações de alarme por e-mail",
    iconAltText: "Usuário",
    addAlarmRecipientsTitle:
      "Adicionar destinatários do monitoramento de condições",
    enterEmailAddressText: "Digite o endereço de e-mail",
    helpText: "Ajuda",
    addRecipientButton: "Adicionar destinatário",
    recipientsListTitle: "Destinatários",
    invalidEmailText: "Endereço de e-mail inválido",
    duplicateEmailText: "O endereço de e-mail já existe",
  },
};

export const alarmProfileEmailRecipientsDrawerModalDe = {
  [pageNameKey]: {
    title: "E-Mail-Empfänger für Condition Monitoring Profil",
    alarmNotificationsSwitchBoxText: "Alarmbenachrichtigungen per E-Mail",
    iconAltText: "Benutzer",
    addAlarmRecipientsTitle: "Empfänger für Condition Monitoring hinzufügen",
    enterEmailAddressText: "E-Mail-Adresse eingeben",
    helpText: "Hilfe",
    addRecipientButton: "Empfänger hinzufügen",
    recipientsListTitle: "Empfängerliste",
    invalidEmailText: "Ungültige E-Mail-Adresse",
    duplicateEmailText: "E-Mail-Adresse existiert bereits",
  },
};

export const alarmProfileEmailRecipientsDrawerModalZhHans = {
  [pageNameKey]: {
    title: "条件监控配置文件电子邮件接收者",
    alarmNotificationsSwitchBoxText: "电子邮件告警通知",
    iconAltText: "用户",
    addAlarmRecipientsTitle: "添加条件监控接收者",
    enterEmailAddressText: "输入电子邮件地址",
    helpText: "帮助",
    addRecipientButton: "添加接收者",
    recipientsListTitle: "接收者列表",
    invalidEmailText: "无效的电子邮件地址",
    duplicateEmailText: "电子邮件地址已存在",
  },
};

export const alarmProfileEmailRecipientsDrawerModalIt = {
  [pageNameKey]: {
    title: "Destinatari e-mail del profilo di monitoraggio delle condizioni",
    alarmNotificationsSwitchBoxText: "Notifiche di allarme via e-mail",
    iconAltText: "Utente",
    addAlarmRecipientsTitle:
      "Aggiungi destinatari del monitoraggio delle condizioni",
    enterEmailAddressText: "Inserisci l'indirizzo email",
    helpText: "Aiuto",
    addRecipientButton: "Aggiungi destinatario",
    recipientsListTitle: "Destinatari",
    invalidEmailText: "Indirizzo e-mail non valido",
    duplicateEmailText: "L'indirizzo e-mail esiste già",
  },
};

export const alarmProfileEmailRecipientsDrawerModalEs = {
  [pageNameKey]: {
    title:
      "Destinatarios del correo electrónico del perfil de supervisión del estado",
    alarmNotificationsSwitchBoxText:
      "Notificaciones de alarma por correo electrónico",
    iconAltText: "Usuario",
    addAlarmRecipientsTitle:
      "Agregar destinatarios de monitoreo de condiciones",
    enterEmailAddressText: "Introduce la dirección de correo electrónico",
    helpText: "Ayuda",
    addRecipientButton: "Agregar destinatario",
    recipientsListTitle: "Destinatarios",
    invalidEmailText: "Dirección de correo electrónico no válida",
    duplicateEmailText: "La dirección de correo electrónico ya existe",
  },
};

export const alarmProfileEmailRecipientsDrawerModalNl = {
  [pageNameKey]: {
    addAlarmRecipientsTitle: "Ontvanger voor conditiebewaking toevoegen",
    addRecipientButton: "Ontvanger toevoegen",
    alarmNotificationsSwitchBoxText: "Alarmmeldingen per e-mail",
    duplicateEmailText: "E-mailadres bestaat al",
    enterEmailAddressText: "E-mailadres invoeren",
    helpText: "Help",
    iconAltText: "Gebruiker",
    invalidEmailText: "Ongeldig e-mailadres",
    recipientsListTitle: "Ontvangerslijst",
    title: "E-mailontvangers conditiebewakingsprofiel",
  },
};

export const alarmProfileEmailRecipientsDrawerModalTr = {
  [pageNameKey]: {
    addAlarmRecipientsTitle: "Durum İzleme Alıcıları Ekle",
    addRecipientButton: "Alıcı Ekle",
    alarmNotificationsSwitchBoxText: "E-posta alarmı bildirimleri",
    duplicateEmailText: "E-posta adresi zaten mevcut",
    enterEmailAddressText: "E-posta adresini girin",
    helpText: "Yardım",
    iconAltText: "Kullanıcı",
    invalidEmailText: "Geçersiz e-posta adresi",
    recipientsListTitle: "Alıcılar",
    title: "Durum İzleme Profili E-posta Alıcıları",
  },
};
